import type { BeckyModelFactory, BeckyModelFactorySync } from '@wix/thunderbolt-becky-root'

export const typedModelFactory = <Model, ExtendFunctionLibrary extends Record<string, Function> = {}>(
	modelFactory: any
): BeckyModelFactory<Model, ExtendFunctionLibrary, Model> => {
	return modelFactory
}

export const typedModelFactorySync = <Model, ExtendFunctionLibrary extends Record<string, Function> = {}>(
	modelFactory: any
): BeckyModelFactorySync<Model, ExtendFunctionLibrary> => {
	return modelFactory
}
